import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { mockData } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-charcoal mb-6">
              {mockData.about.title}
            </h2>
            <div className="w-24 h-1 bg-gold mb-8"></div>
            
            <p className="text-lg text-charcoal/80 mb-8 leading-relaxed">
              {mockData.about.description}
            </p>

            <div className="space-y-4">
              {mockData.about.values.map((value, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0 mt-1" strokeWidth={2} />
                  <span className="text-charcoal/80 text-lg">{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/paella.jpg"
                alt="Traiteur en action"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 to-transparent"></div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gold/20 rounded-full blur-3xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;